import "./button.scss";
import { Spacing } from "../../Redesign/Spacing";
import type { ButtonProps } from "./Button.interface";

/**
 * Primary UI component for user interaction
 */
export function Button(props:ButtonProps) {
  let cssMode: string = "";

  if (props.mode) {
    cssMode = `storybook-button--${props.mode}`;
  }

  function Content() { return (<>
      {props?.icon ? (
        <Spacing alignItems="center">
          {props?.icon}
          {props.label}
        </Spacing>
      ) : (
        props.label
      )}
    </>);
  }

  return (<button
      id={props.id}
      aria-label={props.id}
      type={props.type ? props.type : "button"}
      disabled={props.disabled}
      form={props.form}
      className={[
        "storybook-button",
        cssMode,
        props.className,
        props.border ? `storybook-button--border` : ``,
      ].join(" ")}
      onClick={props.onClick}
      title={props.hoverText}
      style={props.style}
    >
      {props.loading ? (
        <Spacing flexWrap="nowrap" alignItems="center" gap="8" justifyContent="center">
          {props?.loading && (
            <span className="loading-wrapper">
              <span className="loader"></span>
            </span>
          )}
          <Content />
        </Spacing>
      ) : (
        <Content />
      )}
    </button>);
}